"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProperKind = exports.extendTextInfoClassNames = void 0;
const enums_1 = require("./enums");
function extendTextInfoClassNames({ size, fontType, align, segment, display, }) {
    let finalCssClassName = '';
    if (align) {
        finalCssClassName = `${finalCssClassName} text-info-align--${align}`; // se queda
    }
    if (display) {
        finalCssClassName = `${finalCssClassName} text-info-display--${display}`; // se queda
    }
    if (size) {
        finalCssClassName = `${finalCssClassName} text-info-size--${size}`; // se queda
    }
    if (fontType) {
        finalCssClassName = `${finalCssClassName} text-info-${segment}--${fontType}`; // se queda
    }
    return finalCssClassName;
}
exports.extendTextInfoClassNames = extendTextInfoClassNames;
const getProperKind = (kind) => {
    switch (kind) {
        case 'span':
            return enums_1.TEXT_INFO_KIND.SPAN;
        case 'h':
        case 'heading':
            return enums_1.TEXT_INFO_KIND.HEADING;
        case 'p':
        case 'paragraph':
            return enums_1.TEXT_INFO_KIND.PARAGRAPH;
        default:
            return enums_1.TEXT_INFO_KIND.SPAN;
    }
};
exports.getProperKind = getProperKind;
//# sourceMappingURL=utils.js.map